import React, { useEffect, useState } from 'react';
import { BellRing, Loader2, Check } from 'lucide-react';
import { toast } from 'sonner';
import { vehicleAlertsAPI } from '../services/api';

// Garage → alerts: suggests enabling « nouvelles pièces » alerts for saved vehicles (banner or per-vehicle button)
const GarageAlertSuggestion = ({ vehicleId, onDone, compact = false }) => {
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = () => vehicleAlertsAPI.suggestions().then(setData).catch(() => setData({ vehicles: [], missing: 0 }));
  useEffect(() => { load(); }, []);
  if (!data) return null;
  const rows = vehicleId ? data.vehicles.filter((v) => v.vehicle_id === vehicleId) : data.vehicles;
  const missing = rows.filter((v) => !v.subscribed);
  const activate = async (ids) => {
    setBusy(true);
    try {
      const r = await vehicleAlertsAPI.fromGarage(ids);
      toast.success(r.count ? `${r.count} alerte(s) activée(s) pour votre garage` : 'Aucune nouvelle alerte à activer');
      await load(); onDone && onDone(r);
    } catch { toast.error("Impossible d'activer l'alerte"); } finally { setBusy(false); }
  };
  if (compact) {
    const v = rows[0];
    if (!v) return null;
    return v.subscribed
      ? <span className="text-xs text-green-700 inline-flex items-center gap-1" data-testid={`garage-alert-active-${vehicleId}`}><Check size={12} /> Alerte pièces active</span>
      : <button type="button" disabled={busy} onClick={() => activate([vehicleId])} data-testid={`garage-alert-enable-${vehicleId}`} className="text-xs text-[#1e3a5f] hover:underline font-medium inline-flex items-center gap-1">{busy ? <Loader2 size={12} className="animate-spin" /> : <BellRing size={12} />} Alerte nouvelles pièces</button>;
  }
  if (!missing.length) return null;
  return (
    <div className="rounded-xl border border-sky-200 bg-sky-50 p-4 mb-4 flex flex-wrap items-center gap-3" data-testid="garage-alert-banner">
      <BellRing size={18} className="text-sky-700 shrink-0" />
      <div className="flex-1 min-w-[200px]">
        <p className="text-sm font-semibold text-sky-900">{missing.length} véhicule(s) de votre garage sans alerte « nouvelles pièces »</p>
        <p className="text-xs text-sky-800/80 truncate" data-testid="garage-alert-banner-list">{missing.map((v) => `${v.brand} ${v.model}${v.engine ? ` (${v.engine})` : ''}`).join(' · ')}</p>
      </div>
      <button type="button" disabled={busy} onClick={() => activate(missing.map((v) => v.vehicle_id))} data-testid="garage-alert-enable-all" className="inline-flex items-center gap-1.5 rounded-full bg-[#1e3a5f] text-white text-xs font-semibold px-3 py-1.5 disabled:opacity-60">{busy ? <Loader2 size={12} className="animate-spin" /> : <BellRing size={12} />} Activer pour {missing.length > 1 ? 'tous' : 'ce véhicule'} (résumé hebdo)</button>
    </div>
  );
};

export default GarageAlertSuggestion;
